import QrCode2Outlined from '@mui/icons-material/QrCode2Outlined';
import ScienceOutlined from '@mui/icons-material/ScienceOutlined';
import Box from '@mui/material/Box';

function SampleBarcodeIcon() {
  return (
    <Box
      sx={{
        position: 'relative',
        width: 160,
        height: 160,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      aria-hidden="true"
    >
      <ScienceOutlined
        color="primary"
        sx={{
          fontSize: 138,
          position: 'absolute',
        }}
      />

      <QrCode2Outlined
        color="primary"
        sx={{
          fontSize: 58,
          position: 'absolute',
          mt: 7,
        }}
      />
    </Box>
  );
}

export default SampleBarcodeIcon;
